import { render, staticRenderFns } from "./ReceiptSend.vue?vue&type=template&id=5ebfe039&scoped=true&"
import script from "./ReceiptSend.vue?vue&type=script&lang=js&"
export * from "./ReceiptSend.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptSend.vue?vue&type=style&index=0&id=5ebfe039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebfe039",
  null
  
)

export default component.exports